/* TOBS: previous/next arrows for the zoomed product gallery dialog.
   The zoomed list is horizontal on narrow screens and vertical on wide ones,
   and the thumbnail rail moves between bottom and side - so both navigation
   and placement are computed from live geometry. Additive: no Horizon file
   is modified for this beyond the script include. */
(() => {
  const arrow = (dir) => `<button type="button" class="tobs-zoom-nav__btn tobs-zoom-nav__btn--${dir}" aria-label="${dir === 'prev' ? 'Previous image' : 'Next image'}">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="${dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}"/></svg>
  </button>`;

  const enhance = (dialog) => {
    if (dialog.querySelector('.tobs-zoom-nav')) return;
    const list = dialog.querySelector('.dialog-zoomed-gallery');
    if (!list) return;
    const component = dialog.closest('zoom-dialog');
    const nav = document.createElement('div');
    nav.className = 'tobs-zoom-nav';
    nav.innerHTML = arrow('prev') + arrow('next');
    dialog.appendChild(nav);
    const prevBtn = nav.querySelector('.tobs-zoom-nav__btn--prev');
    const nextBtn = nav.querySelector('.tobs-zoom-nav__btn--next');

    /* The list itself may not be the scroller (an ancestor scrolls at some
       widths), so the axis comes from item geometry, not scroll metrics. */
    const items = () => [...list.querySelectorAll(':scope > li')];
    const isVertical = () => {
      const kids = items();
      if (kids.length < 2) return true;
      const a = kids[0].getBoundingClientRect();
      const b = kids[1].getBoundingClientRect();
      return b.top > a.top + 10;
    };

    const place = () => {
      const rail = dialog.querySelector('.dialog-thumbnails-list-container');
      const railRect = rail ? rail.getBoundingClientRect() : null;
      // Keep clear of a side rail: it sits within the viewport and starts
      // past the horizontal midpoint.
      let rightEdge = window.innerWidth;
      if (railRect && railRect.left > window.innerWidth * 0.55 && railRect.top < window.innerHeight * 0.5) {
        rightEdge = railRect.left;
      }
      const mid = window.innerHeight / 2 - 22;
      prevBtn.style.left = '18px';
      nextBtn.style.left = `${rightEdge - 62}px`;
      prevBtn.style.top = nextBtn.style.top = `${mid}px`;
    };
    place();
    window.addEventListener('resize', place);

    const currentIndex = () => {
      const kids = items();
      let best = 0;
      if (isVertical()) {
        const mid = window.innerHeight / 2;
        kids.forEach((li, i) => {
          const lr = li.getBoundingClientRect();
          if (lr.top <= mid && lr.bottom >= mid) best = i;
        });
      } else {
        const mid = window.innerWidth / 2;
        kids.forEach((li, i) => {
          const lr = li.getBoundingClientRect();
          if (lr.left <= mid && lr.right >= mid) best = i;
        });
      }
      return best;
    };
    const go = (delta) => {
      const kids = items();
      const next = Math.min(kids.length - 1, Math.max(0, currentIndex() + delta));
      /* smooth scrollTo/scrollLeft are silently ignored on this scroller;
         instant scrollIntoView is what moves it. The component call keeps
         the thumbnail highlight in sync. */
      kids[next].scrollIntoView({ behavior: 'instant', inline: 'start', block: 'start' });
      if (component && typeof component.handleThumbnailClick === 'function') {
        component.handleThumbnailClick(next);
      }
    };
    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(-1); }
    });
  };

  new MutationObserver(() => {
    document.querySelectorAll('zoom-dialog dialog[open]').forEach(enhance);
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
